import { render, staticRenderFns } from "./PlusIcon.vue?vue&type=template&id=20cd9992&scoped=true&"
import script from "./PlusIcon.vue?vue&type=script&lang=js&"
export * from "./PlusIcon.vue?vue&type=script&lang=js&"
import style0 from "./PlusIcon.vue?vue&type=style&index=0&id=20cd9992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd9992",
  null
  
)

export default component.exports